import { Loader } from "@googlemaps/js-api-loader"
import { useContext, useEffect, useState } from "react"
import SiteContext from "../contexts/SiteContext"

export default function useGoogleMapsLoader() {
    const { aplicativoDados } = useContext(SiteContext)

    const apiKey = aplicativoDados?.tokenGoogleMaps
    const isAppDadosAtualizado = aplicativoDados.timestamp > new Date().getTime() - 10800000 // 3 horas

    const [loader, setLoader] = useState()

    useEffect(() => {
        if (!loader && apiKey && isAppDadosAtualizado) {
            const googleMapsLoader = new Loader({
                apiKey,
                version: "beta",
                libraries: ["places"],
            })

            setLoader(googleMapsLoader)
        }
    }, [apiKey])

    return loader
}
